import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import PlatformIcon from '../common/PlatformIcon';
import { ORANGE_ACTION } from '../../constants/colors';

interface Props {
  currentType?: string;
  onSelect: (type: string) => void;
}

const TYPES = [
  { id: 'restaurant', label: '餐廳', icon: 'restaurant', family: 'MaterialIcons' },
  { id: 'lodging', label: '住宿', icon: 'hotel', family: 'MaterialIcons' },
  { id: 'poi', label: '景點', icon: 'photo_camera', family: 'MaterialIcons' },
  { id: 'shopping', label: '購物', icon: 'shopping_bag', family: 'MaterialIcons' },
  { id: 'activity', label: '活動', icon: 'event', family: 'MaterialIcons' },
];

const CardTypeSelector: React.FC<Props> = ({ currentType, onSelect }) => {
  return (
    <View style={styles.container}>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={styles.scrollContent}>
        {TYPES.map((t) => {
          const isSelected = currentType === t.id;
          return (
            <TouchableOpacity
              key={t.id}
              style={[styles.chip, isSelected && styles.chipSelected]}
              onPress={() => onSelect(t.id)}
            >
              <PlatformIcon
                name={t.icon}
                size={16}
                color={isSelected ? '#fff' : '#6B7280'}
                family={t.family}
              />
              <Text style={[styles.label, isSelected && styles.labelSelected]}>{t.label}</Text>
            </TouchableOpacity>
          );
        })}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 12,
  },
  scrollContent: {
    gap: 8,
    paddingRight: 24, // Add some padding at the end
  },
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    backgroundColor: '#F3F4F6',
    borderWidth: 1,
    borderColor: 'transparent',
  },
  chipSelected: {
    backgroundColor: ORANGE_ACTION,
    borderColor: ORANGE_ACTION,
  },
  label: {
    marginLeft: 6,
    fontSize: 13,
    color: '#6B7280',
    fontWeight: '500',
  },
  labelSelected: {
    color: '#fff',
  },
});

export default CardTypeSelector;
